module.exports = __webpack_public_path__ + "img/phones-dark@2x.235d1704.png";